export function formatAmount(amount: number): string {
    const dollars = amount / 100;
    return dollars.toFixed(2);
}
